var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ow-gloss-name"},[_c('strong',{staticClass:"ow-gloss-name-base"},[_vm._v(_vm._s(_vm.base))]),_vm._v(" "),(_vm.suffix)?_c('span',{staticClass:"ow-gloss-name-suffix"},[_vm._v(_vm._s(_vm.suffix)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }